module.exports = __webpack_public_path__ + "static/media/right-img5.b26ea9b4.png";